module.exports = __webpack_public_path__ + "img/wechat.b4a2df03.png";